import axios from 'axios';
import * as Sentry from '@sentry/react';
import { contactUrl } from './config';

export function SubmitContactUs(data, reCaptchaToken) {
  // replace ios apostrophe
  Object.keys(data).forEach((key) => {
    const value = data[key];
    if (value && typeof value === 'string') {
      data[key] = value.replace(/[‘’]/g, "'");
    }
  });

  return new Promise((resolve, reject) => {
    axios
      .post(contactUrl(), JSON.stringify(data), {
        headers: {
          'x-api-key': process.env.REACT_APP_LAMBDA_X_API_KEY,
          Authorization: reCaptchaToken,
        },
      })
      .then((result) => {
        if (result.status === 200) {
          resolve(200);
        } else {
          reject(result.data);
        }
      })
      .catch((err) => {
        Sentry.captureEvent(err);
        reject(err);
      });
  });
}

export function hideContactError(id) {
  try {
    const errorMsg = document.getElementById(id);
    errorMsg.style.display = 'None';
    errorMsg.removeAttribute('role');
  } catch (e) {
    return undefined;
  }
  return undefined;
}
